// EN-1883: first, so every service's axios.create() gets the account_expired
// interceptor
import './utils/AccountExpiredInterceptor';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { quasarOptions } from './quasar';
import Quasar from 'quasar/src/vue-plugin.js';;
import L from 'leaflet';
import 'setimmediate'; // needed for logdna
import {
  accountExpiredPlan,
  setAccountExpiredHandler,
} from './utils/AccountExpiredInterceptor';
import MessageHub from './services/MessageHub';
import StreamingHub from './services/StreamingHub';
import GroupChatHub from './services/GroupChatHub';
// @ts-expect-error - leaflet image imports handled by webpack
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
// @ts-expect-error - leaflet image import
import iconUrl from 'leaflet/dist/images/marker-icon.png';
// @ts-expect-error - leaflet image import
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

// FIX for leaflet/webpack marker bug
// see https://github.com/PaulLeCam/react-leaflet/issues/255
delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

// Catch known Leaflet bug: layers removed during a zoom animation still receive
// the zoomanim event, causing "_latLngToNewLayerPoint" null reference. Harmless.
window.addEventListener('error', (e) => {
  if (e.error?.message?.includes('_latLngToNewLayerPoint')) {
    e.preventDefault();
  }
});

// EN-1883: a deactivated / expired account is signed out like
// must_change_password, and Login shows the server's message once.
setAccountExpiredHandler((error) => {
  const routeName = router.currentRoute.value.name;
  const plan = accountExpiredPlan(error, {
    signedIn: !!store.state.user,
    onLoginRoute: routeName === 'login' || routeName === 'loginRedirect',
  });
  if (!plan) return;
  MessageHub.stop();
  StreamingHub.stop();
  GroupChatHub.stop();
  store.dispatch('accountExpired', plan.message);
  if (plan.redirect) router.replace({ name: 'login' });
});

const app = createApp(App);
app.use(store);
app.use(router);
app.use(Quasar, quasarOptions);

app.mount('#app');
